import script from "./anticovidView.vue?vue&type=script&setup=true&lang=ts"
export * from "./anticovidView.vue?vue&type=script&setup=true&lang=ts"

import "./anticovidView.vue?vue&type=style&index=0&id=519d94fd&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-519d94fd"]])

export default __exports__